export default __webpack_public_path__ + "static/media/data.f52d34dd.svg";